exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media only screen and (max-width:840px){.mdl-tabs__panel>.scrollbar[_v-84377d3e]{max-height:400px}}@media only screen and (min-width:840px){.mdl-tabs__panel>.scrollbar[_v-84377d3e]{max-height:750px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-84377d3e&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./~/eslint-loader!./src/client/segments/DelayedDetails.vue
// module id = 318
// module chunks = 0